import React from 'react';
import { Link, TextField, useRecordContext } from 'react-admin';
import { HOTLINE_BLOCKLIST_RESOURCE_NAME as HOTLINE_BLOCKLIST_RESOURCE } from '../../hotlineBlocklist.dataProvider';
import { hotlineBlocklistFields } from '../../hotlineBlocklist.model';

const HotlineBlocklistLinkField = ({ source = hotlineBlocklistFields.id, label = 'Id', ...props }) => {
    const record = useRecordContext();
    if (!record || !record[source]) return null;

    return (
        <Link to={`/${HOTLINE_BLOCKLIST_RESOURCE}/${record.id}/show`}>
            <TextField source={source} sx={{ color: 'primary.main' }} label={label} {...props}/>
        </Link>
    );
};

export default HotlineBlocklistLinkField; 